import { useLoading } from "context/LoadingContext";
import { ToastContext } from "context/ToastContext";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateModifierAdjustmentMutation } from "store/queries/modifierAdjustments";

import {
  IProfessionalModifierFormData,
  INITIAL_PROFESSIONAL_MODIFIER_FORM_DATA,
  ProfessionalModifierForm,
} from "./components/ProfessionalModifierForm";

export function CreateProfessionalModifierPage() {
  useDocumentTitle("Create Professional Modifier Rule");
  const navigate = useNavigate();
  const { setIsLoading } = useLoading();
  const { current: toastElement } = useContext(ToastContext);
  const [createMutation, { isLoading }] = useCreateModifierAdjustmentMutation();
  const [formData, setFormData] = useState<IProfessionalModifierFormData>(
    INITIAL_PROFESSIONAL_MODIFIER_FORM_DATA
  );

  const handleSubmit = async () => {
    if (!formData.modifier.trim()) return;
    if (!formData.isDefault && !formData.providerId) return;
    setIsLoading(true);
    try {
      await createMutation({
        modifier: formData.modifier.trim().toUpperCase(),
        multiplier: formData.multiplier,
        cptCodes: formData.cptCodes.map((c) => c.trim()).filter(Boolean),
        groupName: formData.groupName.trim() || null,
        isDefault: formData.isDefault,
        providerId: formData.isDefault ? null : formData.providerId,
        payerId: formData.isDefault ? null : formData.payerId,
      }).unwrap();
      toastElement?.show({
        severity: "success",
        summary: "Created!",
        detail: "Professional modifier rule created successfully.",
      });
      navigate("/payer-rules");
    } catch (error: any) {
      toastElement?.show({
        severity: "error",
        summary: "Error",
        detail:
          error?.data?.message || "Failed to create professional modifier rule",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ProfessionalModifierForm
      title="Create Professional Modifier Rule"
      submitLabel="Create Rule"
      formData={formData}
      onChange={setFormData}
      onSubmit={handleSubmit}
      isSubmitting={isLoading}
    />
  );
}
